import React, { memo } from 'react';
import { Shield, Lock, CreditCard, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';

const V = '#7FB342';

const TrustBadges = memo(() => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const tp = isDark ? '#F0EFFF' : '#1A1A2E';
  const ts = isDark ? '#9998B8' : '#6B6B8A';
  const bg = isDark ? 'rgba(26,26,46,0.5)' : 'rgba(255,255,255,0.7)';
  const bd = isDark ? '#2E2E45' : '#E5E3F0';

  const badges = [
    { icon: Shield, title: t('trust.rgpd_title', 'RGPD conforme'), desc: t('trust.rgpd_desc', 'Données protégées'), color: '#059669' },
    { icon: Lock, title: t('trust.encrypted_title', 'Chiffré E2E'), desc: t('trust.encrypted_desc', 'TLS + AES-256'), color: '#2563EB' },
    { icon: CreditCard, title: t('trust.stripe_title', 'Paiement Stripe'), desc: t('trust.stripe_desc', '100% sécurisé'), color: '#7FB342' },
    { icon: Trash2, title: t('trust.autodelete_title', 'Suppression auto'), desc: t('trust.autodelete_desc', 'Après analyse'), color: '#DC2626' }
  ];

  return (
    <section className="py-8 px-4" data-testid="trust-badges-section">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {badges.map((b, i) => (
            <div key={i}
              className="flex items-center gap-2 rounded-xl p-3 backdrop-blur"
              style={{ background: bg, border: `1px solid ${bd}` }}
              data-testid={`trust-badge-${i}`}>
              <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0" style={{ background: `${b.color}15` }}>
                <b.icon className="h-4 w-4" style={{ color: b.color }} />
              </div>
              <div className="min-w-0">
                <p className="text-xs font-semibold truncate" style={{ color: tp }}>{b.title}</p>
                <p className="text-[10px] truncate" style={{ color: ts }}>{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

TrustBadges.displayName = 'TrustBadges';
export default TrustBadges;
